<lms-modal #modalItineraryPublish size="small">
  <div class="gl-popup__title">{{ 'itineraries.notification.titlePublish' | translate }}</div>
  <div class="gl-popup__close" (click)="close()">
    <span class="glicon-close"></span>
  </div>
  <div class="gl-popup__text">{{ 'itineraries.notification.messagePublish' | translate }}</div>
  <div class="gl-popup__buttons">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="close()"> </gl-button>
    <gl-button color-primary [text]="'actions.publish' | translate" (onClick)="publishItinerary()"> </gl-button>
  </div>
</lms-modal>
